import React from 'react';
import { register } from '../../i18n';

const t = register('GlobalQuestionLabels');

const ShowPreviousResponseConfirmDialog = ({ isOpen, onConfirm, onCancel, message }) => {
  if (!isOpen) return null;

  return (
    <div className="show-previous-response-overlay">
      <div className="show-previous-response-dialog">
        <div className="show-previous-response-header">
          <h3>{t('showPreviousResponse')}</h3>
        </div>
        <div className="show-previous-response-body">
          <p>{message || t('showPreviousResponseWarning')}</p>
        </div>
        <div className="show-previous-response-actions">
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            type="button"
          >
            {t('cancel')}
          </button>
          <button
            className="btn btn-primary"
            onClick={onConfirm}
            type="button"
          >
            {t('continue')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShowPreviousResponseConfirmDialog;
